import setAccessType from './SetAccessType';
export default setAccessType;
